import HttpService from './HttpService';

export type DividaVisualizada = { dividaId: number, ofertaId: number | null };

class TrackingService extends HttpService {
  notificarAcesso(cpf: string, tema: string) {
    const payload = {
      cpf,
      tema,
      url: window.location.href,
      referrer: document.referrer,
    };
    return this.post<void>('/api/portal/HistoricoAcesso', payload);
  }
}

const trackingService = new TrackingService();
export default trackingService;
